import { useRef } from 'react';
import type { ReactNode } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { panelIds } from './types';
import Menu from './Menu';
import type { MenuProps } from './Menu';

type MenuDialogProps = MenuProps & {
  open: boolean;
  header: ReactNode;
  onClose: () => void;
  onClosed: () => void;
};

export default function MenuDialog({
  open,
  header,
  onClose,
  onClosed,
  ...menuProps
}: MenuDialogProps) {
  const menuRef = useRef<HTMLElement>(null);

  return (
    <Dialog.Root open={open} onOpenChange={(next) => !next && onClose()}>
      <Dialog.Portal>
        <div className="bio-mobile-navigation">
          <Dialog.Overlay className="bio-mobile-dialog__overlay" />
          <Dialog.Content
            className="bio-mobile-dialog right-scroll-bar-position"
            aria-describedby={undefined}
            onOpenAutoFocus={(event) => {
              event.preventDefault();
              menuRef.current?.focus();
            }}
            onCloseAutoFocus={(event) => {
              // The hidden opener lost focus on open, so Radix can't restore it.
              event.preventDefault();
              onClosed();
            }}
          >
            <Dialog.Title className="sr-only">Mobile navigation</Dialog.Title>
            {header}
            <nav
              ref={menuRef}
              id={panelIds.menu}
              className="bio-mobile-menu"
              aria-label="Main navigation"
              tabIndex={-1}
            >
              <Menu {...menuProps} />
            </nav>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
